'use client';

import { LoginLink } from "@kinde-oss/kinde-auth-nextjs/components";
import { Mail } from "lucide-react";
import Link from "next/link";
import { useState } from "react";
import CartaAILogo from '@/../public/images/Carta-ai_Logo.png';
import Image from "next/image";
import { Button } from "@/components/ui/button";

export default function CustomLoginPage() {
  const [email, setEmail] = useState("");

  console.log(process.env.NEXT_PUBLIC_KINDE_GOOGLE_CONNECTION_ID);

  const handleManualLogin = () => {
    const searchParams = new URLSearchParams({
      response_type: "code",
      client_id: process.env.NEXT_PUBLIC_KINDE_CLIENT_ID!,
      redirect_uri: `${window.location.origin}/api/auth/kinde_callback`,
      scope: "openid profile email",
      connection_id: process.env.NEXT_PUBLIC_KINDE_GOOGLE_CONNECTION_ID!, // Your Google Connection ID
      prompt: "select_account",
      state: "fa7f2f549669a8c259bf4eea5a7f"
    });

    window.location.href = `https://experstsm.kinde.com?${searchParams.toString()}`;
    // window.location.href = `http://localhost:3000/api/auth/kinde_callback?${searchParams.toString()}`;
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 px-4 py-12">
      <Link href="/">
        <div className="relative w-52 h-20 mb-4">
          <Image src={CartaAILogo} alt="Carta AI Logo" fill className="object-contain" />
        </div>
      </Link>
      <div className="max-w-md w-full space-y-8 bg-white dark:bg-gray-800 p-10 rounded-2xl shadow-xl border border-gray-100 dark:border-gray-700">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 dark:text-white">Sign In</h2>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">Access your professional career tools</p>
        </div>

        <div className="mt-8 space-y-4">
          {/* Email/Password Section */}
          <div className="space-y-4">
            <div className="relative">
              <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
              <input
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                className="pl-10 block w-full border-gray-300 rounded-md shadow-sm p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white sm:text-sm"
                placeholder="Email address"
              />
            </div>
            <LoginLink
              authUrlParams={{
                connection_id: "YOUR_EMAIL_CONNECTION_ID", // Find in Kinde Settings > Authentication
                login_hint: email,
              }}
              className="w-full flex justify-center py-2.5 px-4 rounded-md text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Sign in with Email
            </LoginLink>
          </div>

          {/* Divider */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center"><span className="w-full border-t border-gray-300"></span></div>
            <div className="relative flex justify-center text-xs uppercase"><span className="px-2 bg-white dark:bg-gray-800 text-gray-500">Or continue with</span></div>
          </div>

          {/* Social Providers Grid */}
          <div className="grid grid-cols-1 gap-3">
            {/* Google */}
            
            {/* ******************************************************************* */}
            {/* ******************************************************************* */}
            <LoginLink
              authUrlParams={{ connection_id: process.env.NEXT_PUBLIC_KINDE_GOOGLE_CONNECTION_ID!, prompt: "select_account" }}
              className="flex items-center justify-center gap-2 py-2.5 border border-gray-300 rounded-md bg-white hover:bg-gray-50 text-sm font-medium text-gray-700 transition"
            >
              <img src="/images/google_logo.png" alt="Google" className="w-5 h-5" /> Google
              
            </LoginLink>
            {/* <Button 
              className="flex items-center justify-center gap-2 py-2.5 border border-gray-300 rounded-md bg-white hover:bg-gray-50 text-sm font-medium text-gray-700 transition"
              onClick={handleManualLogin}
            >
              <img src="/images/google_logo.png" alt="Google" className="w-5 h-5" /> Google
            </Button> */}
            {/* ******************************************************************* */}
            {/* ******************************************************************* */}

            {/* Facebook */}
            {/* <LoginLink
              authUrlParams={{ connection_id: process.env.NEXT_PUBLIC_KINDE_FACEBOOK_CONNECTION_ID! }}
              className="flex items-center justify-center gap-2 py-2.5 border border-gray-300 rounded-md bg-[#1877F2] hover:bg-[#166fe5] text-sm font-medium text-white transition"
            >
              <img src="/images/facebook.png" alt="Facebook" className="w-5 h-5" /> Facebook
            </LoginLink> */}

            {/* X (Twitter) */}
            {/* <LoginLink
              authUrlParams={{ connection_id: process.env.NEXT_PUBLIC_KINDE_X_CONNECTION_ID! }}
              className="flex items-center justify-center gap-2 py-2.5 border border-gray-300 rounded-md bg-black hover:bg-gray-900 text-sm font-medium text-white transition"
            >
              <img src="/images/x.png" alt="X" className="w-5 h-5" /> Continue on X
            </LoginLink> */}
          </div>
        </div>

        <p className="mt-8 text-center text-sm text-gray-500">
          New to Carta AI? <a href="/auth/register" className="font-medium text-indigo-600 hover:text-indigo-500">Create an account</a>
        </p>
        <p className="mt-8 text-center text-sm text-gray-500">
          <a href="/" className="font-medium text-indigo-600 hover:text-indigo-500">
            ← Go back to Home Page
          </a>
        </p>
      </div>
    </div>
  );
}